import { useState, useContext, useEffect } from "react";
import Header from "../../../components/Header";
import "../styles/dashboard.css";
import { dashboardPoliciesIcon, dashboardCalendarIcon ,  QueriesBanner , windowClosedBanner } from "../../../Assets";
import DashboardTabs from "../../../components/DashboardTabs";
import DashboardFeatures from "../../../components/DashboardFeatures";
import WellnessFeatures from "../../../components/WellnessFeatures";
import { NotokenFound } from "../../../Utils";
import { useNavigate } from "react-router-dom";
import { AppContext, mainAPikey } from "../../../ContextApi";
import { IoAdd } from "react-icons/io5";
import EnrollmentSummaryPopup from "../../../components/EnrollmentSummaryPopup";

const Dashboard = () => {
  const navigate = useNavigate();

  const [appLinkToken, setappLinkToken] = useState(null);
  const [show, setShow] = useState(false);
  const { requestOptions, tabapiData } = useContext(AppContext);
  const [token, setToken] = useState(
    localStorage.getItem("authorizationToken") || ""
  );

  const [enrollmentData, setEnrollmentData] = useState([]);
  const [enrollmentSummaryData, setEnrollmentSummaryData] = useState([]);

  useEffect(() => {
    const fetchEnrollmentDetails = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/${mainAPikey}/employee/enrollment-details`,
          requestOptions
        );
        const res = await response.json();
        if (res.status) {
          setEnrollmentData(res);
        }
        if (!token) {
          NotokenFound(navigate);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const fetchEnrollmentSummaryDetails = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/${mainAPikey}/employee/enrollment-summary`,
          requestOptions
        );
        const res = await response.json();
        if (res.success) {
          setEnrollmentSummaryData(res);
        }
        if (!token) {
          NotokenFound(navigate);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchEnrollmentSummaryDetails();

    fetchEnrollmentDetails();
  }, []);

  const requestOptionsNew = { ...requestOptions };
  requestOptionsNew.method = "POST";

  useEffect(() => {
    if (mainAPikey) {
      async function getV1TokenAutoLogin() {
        try {
          const response = await fetch(
            process.env.REACT_APP_API_URL +
              `/${mainAPikey}` +
              `/employee/auto-login`,
            requestOptionsNew
          );
          const data = await response.json();
          if (data.success === true) {
            localStorage.setItem("appLinkToken", data?.data?.token);
            setappLinkToken(data?.data?.token);
          }
        } catch (error) {
          console.error(error);
        }
      }
      getV1TokenAutoLogin();
    }
  }, [token, mainAPikey]);

  const handleSummaryPopup = () => {};

  return (
    <>
      <div className="">
        <Header />
        <div className="dashboard-main-cover-wrapper dashboard-inner-cover-wrapper">
          <div className="dashboard-header-banner-box">
            <div className="row">
              <div className="col-lg-4">
                <div className="row d-flex align-items-center dashboard-top-card">
                  <div className="col-lg-12">
                    <div className="dashboard-policies-main-cover-wrapper">
                      <div className="dashboard-polices-title-box">
                        <img src={dashboardPoliciesIcon}></img>
                        <h5>My Policies</h5>
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-lg-1">
                    <div className="policies-right-icon">
                      <FaArrowRightLong />
                    </div>
                  </div> */}
                  <DashboardTabs />
                </div>
              </div>
              <div className="col-lg-4">
                <div
                  className={
                    enrollmentData?.status
                      ? "active-enrollment-dashboard dashboard-enrollment-cover-box"
                      : "dashboard-enrollment-cover-box"
                  }
                >
                  {!enrollmentData?.status ? (
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="dasboard-enrollment-title-box">
                          <h6>Enrollment Window</h6>

                          <span className="dashboard-enroll-status d-flex w-100">
                            Closed
                          </span>
                          <button
                            className="dashboard-enroll-btn"
                            onClick={() => setShow(!show)}
                          >
                            View Summary
                          </button>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="dasboard-enrollment-calendar-box-cover-wrapper">
                          <div className="dashboard-enrollment-calendar">
                            <img src={windowClosedBanner}></img>
                            {/* <h5>
                              {enrollmentData?.data?.remaining_days}{" "}
                              <span>days</span>
                            </h5> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="dasboard-enrollment-title-box">
                          <h6>Enrollment Window</h6>

                          <span className="dashboard-enroll-status d-flex w-100">
                            OPEN
                          </span>
                          <button
                            className="dashboard-enroll-btn"
                            onClick={() =>
                              window.open(enrollmentData?.data?.enrolment_link)
                            }
                          >
                            Click Here
                          </button>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="dasboard-enrollment-calendar-box-cover-wrapper">
                          <div className="dashboard-enrollment-calendar">
                            <img src={dashboardCalendarIcon}></img>
                            <h5>
                              {enrollmentData?.data?.remaining_days}{" "}
                              <span>days</span>
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="col-lg-4">
                <div className="dashboard-enrollment-cover-box d-flex align-items-center gap-3">
                  <div className="dashboard-queries-box">
                    <img src={QueriesBanner} alt="Queries banner"></img>
                  </div>
                  <div className="dashboard-qeries-box">
                    <h5>Need Assistance?</h5>
                    <p>Submit Your Employee Query.</p>
                    <button className="add-new-queries-btn float-start" onClick={() =>navigate("/queries")}>
                      <IoAdd />
                      Raise Queries
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="dashboard-content-box-cover">
            <div className="row">
              {/* <div className="col-lg-4">
                <DashboardFeatureDetails
                  enrollmentSummaryData={enrollmentSummaryData}
                />
              </div> */}

              <div className="col-lg-12">
                <div className="dashboard-wellness-feature-title-box mt-0">
                  <h5 className="dashboard-wellness-feature-title">
                    Employee Benefits
                  </h5>
                </div>
                <DashboardFeatures />
              </div>
              <div className="col-lg-12">
                <WellnessFeatures appLinkToken={appLinkToken} />
              </div>
            </div>
          </div>
          {/* <WellnessVideos /> */}
        </div>
        <EnrollmentSummaryPopup
          enrollmentSummaryData={enrollmentSummaryData}
          setShow={setShow}
          show={show}
        />
      </div>
    </>
  );
};

export default Dashboard;
